import React from "react";

/**
 * BeeNest mascot — created by Evelyn Villanueva (IM•BEE).
 * Used sparingly across the app: onboarding, encouragement, calm transitions,
 * emotional support, bedtime, breathing. Do NOT add to every screen.
 *
 * Props:
 *   size     — pixel width (height auto-matches via square aspect)
 *   variant  — "portrait" (default, transparent background, fits tight UI)
 *              "card"     (warm honey plaque, app-icon-style)
 *              "flower"   (companion variant with flower, onboarding hero)
 *   className — passthrough for layout
 *   ariaLabel — accessible label (default "BeeNest")
 */
export const BeeLogo = ({
  size = 48,
  variant = "portrait",
  className = "",
  ariaLabel = "BeeNest",
}) => {
  const src =
    variant === "card"
      ? "/bee-mascot.png"
      : variant === "flower"
      ? "/bee-mascot-flower.png"
      : "/bee-portrait.png";

  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={ariaLabel}
      role="img"
      draggable={false}
      decoding="async"
      loading="eager"
      className={className}
      style={{
        width: size,
        height: variant === "flower" ? "auto" : size,
        display: "inline-block",
        userSelect: "none",
      }}
      data-testid="bee-logo"
    />
  );
};

export default BeeLogo;
